import React from 'react'

export default function InputField({type,value,onChange,name, onBlur,placeholder,className}) {
  return (
    <input className={className} type={type} value={value} onChange={onChange} name={name} onBlur={onBlur} placeholder={placeholder} ></input>
    )
}
